module.exports = __webpack_public_path__ + "static/img/5.f8a1188d.svg";